import { c as _c } from "react/compiler-runtime";
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { LocaleEnum } from '@systemeio/ui';
import { AutomationsIcon, BlogsIcon, ContactsIcon, DashboardIcon, EmailsIcon, HelpIcon, ManInSuit, ProductsIcon, SalesIcon, SmsMenuIcon, UpgradeIcon } from '@systemeio/ui/icons';
import { GrowthbookFlagsEnum } from 'growthbook/types';
import { AdminRolesEnum } from 'shared/enums/user-roles-enum';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { formUrl } from 'shared/utils/links/form-url';
import { MenuItemType } from '../types/menu-interface';
import { useRouter } from 'next/router';
import { isSIO } from 'shared/utils/is-sio';
export const useMenuItems = () => {
  const $ = _c(432);
  const {
    t
  } = useLocoTranslation();
  const {
    checkAdminRoles,
    user,
    isWorkspaceOwner,
    isSubAccountImpersonation,
    isSupportImpersonation,
    isWsAssistant,
    isCustomer,
    isAffiliate,
    isStudent,
    isWsAdmin,
    isRootAdmin
  } = useUser();
  const whiteLabelFeatureIsOn = useFeatureIsOn(GrowthbookFlagsEnum.WhiteLabel);
  let t0;
  if ($[0] !== checkAdminRoles) {
    t0 = checkAdminRoles([AdminRolesEnum.support, AdminRolesEnum.admin, AdminRolesEnum.superAdmin]);
    $[0] = checkAdminRoles;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isRegularAdmin = t0;
  const {
    pathname
  } = useRouter();
  let t1;
  if ($[2] !== pathname) {
    t1 = url => pathname.includes(url);
    $[2] = pathname;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const regularIsActiveCheck = t1;
  const t2 = user?.userPlanId === 40 && isWorkspaceOwner && !isSupportImpersonation;
  let t3;
  if ($[4] !== t) {
    t3 = t("header.top_menu.upgrade");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== regularIsActiveCheck || $[7] !== t2 || $[8] !== t3) {
    t4 = {
      href: "/profile/user-plan",
      shouldRender: t2,
      mobileIconRenderer: _temp,
      name: t3,
      isActive: regularIsActiveCheck
    };
    $[6] = regularIsActiveCheck;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t) {
    t5 = t("header.top_menu.dashboard");
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t("header.top_menu.main_dashboard");
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const t7 = (isWorkspaceOwner || isWsAdmin) && isCustomer;
  let t8;
  if ($[14] !== pathname) {
    t8 = url_0 => pathname === url_0;
    $[14] = pathname;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t6 || $[17] !== t7 || $[18] !== t8) {
    t9 = {
      name: t6,
      href: "/",
      shouldRender: t7,
      isActive: t8
    };
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t) {
    t10 = t("header.top_menu.affiliate_dashboard");
    $[20] = t;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  const t11 = isWorkspaceOwner && isAffiliate;
  let t12;
  if ($[22] !== regularIsActiveCheck || $[23] !== t10 || $[24] !== t11) {
    t12 = {
      name: t10,
      href: "/affiliate-dashboard",
      shouldRender: t11,
      isActive: regularIsActiveCheck
    };
    $[22] = regularIsActiveCheck;
    $[23] = t10;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t) {
    t13 = t("header.top_menu.student_dashboard");
    $[26] = t;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== isStudent) {
    t14 = isStudent ? formUrl("/school", false) ?? "" : formUrl("/school?tab=explore_courses", false) ?? "";
    $[28] = isStudent;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== isStudent || $[31] !== regularIsActiveCheck || $[32] !== t13 || $[33] !== t14) {
    t15 = {
      name: t13,
      shouldRender: isStudent,
      href: t14,
      isActive: regularIsActiveCheck
    };
    $[30] = isStudent;
    $[31] = regularIsActiveCheck;
    $[32] = t13;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t) {
    t16 = t("header.top_menu.agency_dashboard");
    $[35] = t;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  bb0: {
    if (!whiteLabelFeatureIsOn) {
      t17 = false;
      break bb0;
    }
    if (isSubAccountImpersonation) {
      t17 = false;
      break bb0;
    }
    if (!isCustomer) {
      t17 = false;
      break bb0;
    }
    if (!isWorkspaceOwner) {
      t17 = false;
      break bb0;
    }
    if (isRootAdmin) {
      t17 = false;
      break bb0;
    }
    let t18;
    if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
      t18 = isSIO();
      $[37] = t18;
    } else {
      t18 = $[37];
    }
    t17 = t18;
  }
  let t18;
  if ($[38] !== pathname) {
    t18 = () => pathname.includes("/agency-center");
    $[38] = pathname;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== t16 || $[41] !== t17 || $[42] !== t18) {
    t19 = {
      name: t16,
      href: "/agency-center/white-label-users",
      shouldRender: t17,
      isActive: t18
    };
    $[40] = t16;
    $[41] = t17;
    $[42] = t18;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  let t20;
  if ($[44] !== t12 || $[45] !== t15 || $[46] !== t19 || $[47] !== t9) {
    t20 = [t9, t12, t15, t19];
    $[44] = t12;
    $[45] = t15;
    $[46] = t19;
    $[47] = t9;
    $[48] = t20;
  } else {
    t20 = $[48];
  }
  let t21;
  if ($[49] !== t20 || $[50] !== t5) {
    t21 = {
      name: t5,
      dropdownItems: t20,
      mobileIconRenderer: _temp2
    };
    $[49] = t20;
    $[50] = t5;
    $[51] = t21;
  } else {
    t21 = $[51];
  }
  let t22;
  if ($[52] !== t) {
    t22 = t("header.top_menu.crm");
    $[52] = t;
    $[53] = t22;
  } else {
    t22 = $[53];
  }
  let t23;
  if ($[54] !== t) {
    t23 = t("header.top_menu.contacts");
    $[54] = t;
    $[55] = t23;
  } else {
    t23 = $[55];
  }
  const t24 = isWsAssistant ? "/assistant/contacts" : "/contacts";
  let t25;
  if ($[56] !== isCustomer || $[57] !== regularIsActiveCheck || $[58] !== t23 || $[59] !== t24) {
    t25 = {
      name: t23,
      href: t24,
      isActive: regularIsActiveCheck,
      shouldRender: isCustomer
    };
    $[56] = isCustomer;
    $[57] = regularIsActiveCheck;
    $[58] = t23;
    $[59] = t24;
    $[60] = t25;
  } else {
    t25 = $[60];
  }
  let t26;
  if ($[61] !== t) {
    t26 = t("header.top_menu.tags");
    $[61] = t;
    $[62] = t26;
  } else {
    t26 = $[62];
  }
  let t27;
  if ($[63] !== isCustomer || $[64] !== regularIsActiveCheck || $[65] !== t26) {
    t27 = {
      name: t26,
      href: "/tags",
      isActive: regularIsActiveCheck,
      shouldRender: isCustomer
    };
    $[63] = isCustomer;
    $[64] = regularIsActiveCheck;
    $[65] = t26;
    $[66] = t27;
  } else {
    t27 = $[66];
  }
  let t28;
  if ($[67] !== t) {
    t28 = t("header.top_menu.crm_pipeline");
    $[67] = t;
    $[68] = t28;
  } else {
    t28 = $[68];
  }
  let t29;
  if ($[69] !== isCustomer || $[70] !== regularIsActiveCheck || $[71] !== t28) {
    t29 = {
      name: t28,
      href: "/crm-pipeline",
      isActive: regularIsActiveCheck,
      shouldRender: isCustomer
    };
    $[69] = isCustomer;
    $[70] = regularIsActiveCheck;
    $[71] = t28;
    $[72] = t29;
  } else {
    t29 = $[72];
  }
  let t30;
  if ($[73] !== t) {
    t30 = t("header.top_menu.calendar");
    $[73] = t;
    $[74] = t30;
  } else {
    t30 = $[74];
  }
  let t31;
  if ($[75] !== isCustomer || $[76] !== regularIsActiveCheck || $[77] !== t30) {
    t31 = {
      name: t30,
      href: "/calendar",
      isActive: regularIsActiveCheck,
      shouldRender: isCustomer
    };
    $[75] = isCustomer;
    $[76] = regularIsActiveCheck;
    $[77] = t30;
    $[78] = t31;
  } else {
    t31 = $[78];
  }
  let t32;
  if ($[79] !== t25 || $[80] !== t27 || $[81] !== t29 || $[82] !== t31) {
    t32 = [t25, t27, t29, t31];
    $[79] = t25;
    $[80] = t27;
    $[81] = t29;
    $[82] = t31;
    $[83] = t32;
  } else {
    t32 = $[83];
  }
  let t33;
  if ($[84] !== t22 || $[85] !== t32) {
    t33 = {
      name: t22,
      dropdownItems: t32,
      mobileIconRenderer: _temp3
    };
    $[84] = t22;
    $[85] = t32;
    $[86] = t33;
  } else {
    t33 = $[86];
  }
  let t34;
  if ($[87] !== t) {
    t34 = t("header.top_menu.sites");
    $[87] = t;
    $[88] = t34;
  } else {
    t34 = $[88];
  }
  let t35;
  if ($[89] !== t) {
    t35 = t("header.top_menu.website");
    $[89] = t;
    $[90] = t35;
  } else {
    t35 = $[90];
  }
  let t36;
  if ($[91] !== isCustomer || $[92] !== regularIsActiveCheck || $[93] !== t35) {
    t36 = {
      name: t35,
      href: "/websites",
      shouldRender: isCustomer,
      isActive: regularIsActiveCheck
    };
    $[91] = isCustomer;
    $[92] = regularIsActiveCheck;
    $[93] = t35;
    $[94] = t36;
  } else {
    t36 = $[94];
  }
  let t37;
  if ($[95] !== t) {
    t37 = t("header.top_menu.funnels");
    $[95] = t;
    $[96] = t37;
  } else {
    t37 = $[96];
  }
  let t38;
  if ($[97] !== isCustomer || $[98] !== regularIsActiveCheck || $[99] !== t37) {
    t38 = {
      name: t37,
      href: "/funnels",
      isActive: regularIsActiveCheck,
      shouldRender: isCustomer
    };
    $[97] = isCustomer;
    $[98] = regularIsActiveCheck;
    $[99] = t37;
    $[100] = t38;
  } else {
    t38 = $[100];
  }
  let t39;
  if ($[101] !== t) {
    t39 = t("header.top_menu.digital_stores");
    $[101] = t;
    $[102] = t39;
  } else {
    t39 = $[102];
  }
  let t40;
  if ($[103] !== isCustomer || $[104] !== regularIsActiveCheck || $[105] !== t39) {
    t40 = {
      name: t39,
      href: "/stores",
      isActive: regularIsActiveCheck,
      shouldRender: isCustomer
    };
    $[103] = isCustomer;
    $[104] = regularIsActiveCheck;
    $[105] = t39;
    $[106] = t40;
  } else {
    t40 = $[106];
  }
  let t41;
  if ($[107] !== t) {
    t41 = t("header.top_menu.blogs");
    $[107] = t;
    $[108] = t41;
  } else {
    t41 = $[108];
  }
  let t42;
  if ($[109] !== isCustomer || $[110] !== regularIsActiveCheck || $[111] !== t41) {
    t42 = {
      name: t41,
      href: "/blogs",
      isActive: regularIsActiveCheck,
      shouldRender: isCustomer
    };
    $[109] = isCustomer;
    $[110] = regularIsActiveCheck;
    $[111] = t41;
    $[112] = t42;
  } else {
    t42 = $[112];
  }
  let t43;
  if ($[113] !== t36 || $[114] !== t38 || $[115] !== t40 || $[116] !== t42) {
    t43 = [t36, t38, t40, t42];
    $[113] = t36;
    $[114] = t38;
    $[115] = t40;
    $[116] = t42;
    $[117] = t43;
  } else {
    t43 = $[117];
  }
  let t44;
  if ($[118] !== t34 || $[119] !== t43) {
    t44 = {
      name: t34,
      dropdownItems: t43,
      mobileIconRenderer: _temp4
    };
    $[118] = t34;
    $[119] = t43;
    $[120] = t44;
  } else {
    t44 = $[120];
  }
  let t45;
  if ($[121] !== t) {
    t45 = t("header.top_menu.emails");
    $[121] = t;
    $[122] = t45;
  } else {
    t45 = $[122];
  }
  let t46;
  if ($[123] !== t) {
    t46 = t("header.top_menu.newsletters");
    $[123] = t;
    $[124] = t46;
  } else {
    t46 = $[124];
  }
  let t47;
  if ($[125] !== isCustomer || $[126] !== regularIsActiveCheck || $[127] !== t46) {
    t47 = {
      name: t46,
      href: "/newsletters",
      isActive: regularIsActiveCheck,
      shouldRender: isCustomer
    };
    $[125] = isCustomer;
    $[126] = regularIsActiveCheck;
    $[127] = t46;
    $[128] = t47;
  } else {
    t47 = $[128];
  }
  let t48;
  if ($[129] !== t) {
    t48 = t("header.top_menu.campaigns");
    $[129] = t;
    $[130] = t48;
  } else {
    t48 = $[130];
  }
  let t49;
  if ($[131] !== isCustomer || $[132] !== regularIsActiveCheck || $[133] !== t48) {
    t49 = {
      name: t48,
      href: "/campaigns",
      isActive: regularIsActiveCheck,
      shouldRender: isCustomer
    };
    $[131] = isCustomer;
    $[132] = regularIsActiveCheck;
    $[133] = t48;
    $[134] = t49;
  } else {
    t49 = $[134];
  }
  let t50;
  if ($[135] !== t) {
    t50 = t("header.top_menu.email_statistics");
    $[135] = t;
    $[136] = t50;
  } else {
    t50 = $[136];
  }
  let t51;
  if ($[137] !== isCustomer || $[138] !== regularIsActiveCheck || $[139] !== t50) {
    t51 = {
      name: t50,
      href: "/email-statistics",
      isActive: regularIsActiveCheck,
      shouldRender: isCustomer
    };
    $[137] = isCustomer;
    $[138] = regularIsActiveCheck;
    $[139] = t50;
    $[140] = t51;
  } else {
    t51 = $[140];
  }
  let t52;
  if ($[141] !== t47 || $[142] !== t49 || $[143] !== t51) {
    t52 = [t47, t49, t51];
    $[141] = t47;
    $[142] = t49;
    $[143] = t51;
    $[144] = t52;
  } else {
    t52 = $[144];
  }
  let t53;
  if ($[145] !== t45 || $[146] !== t52) {
    t53 = {
      name: t45,
      dropdownItems: t52,
      mobileIconRenderer: _temp5
    };
    $[145] = t45;
    $[146] = t52;
    $[147] = t53;
  } else {
    t53 = $[147];
  }
  let t54;
  if ($[148] !== t) {
    t54 = t("header.top_menu.sms");
    $[148] = t;
    $[149] = t54;
  } else {
    t54 = $[149];
  }
  let t55;
  if ($[150] !== t) {
    t55 = t("header.top_menu.sms_templates");
    $[150] = t;
    $[151] = t55;
  } else {
    t55 = $[151];
  }
  let t56;
  if ($[152] !== isCustomer || $[153] !== regularIsActiveCheck || $[154] !== t55) {
    t56 = {
      name: t55,
      href: "/sms/templates",
      isActive: regularIsActiveCheck,
      shouldRender: isCustomer
    };
    $[152] = isCustomer;
    $[153] = regularIsActiveCheck;
    $[154] = t55;
    $[155] = t56;
  } else {
    t56 = $[155];
  }
  let t57;
  if ($[156] !== t) {
    t57 = t("header.top_menu.sms_statistics");
    $[156] = t;
    $[157] = t57;
  } else {
    t57 = $[157];
  }
  let t58;
  if ($[158] !== isCustomer || $[159] !== regularIsActiveCheck || $[160] !== t57) {
    t58 = {
      name: t57,
      href: "/sms/statistics",
      isActive: regularIsActiveCheck,
      shouldRender: isCustomer
    };
    $[158] = isCustomer;
    $[159] = regularIsActiveCheck;
    $[160] = t57;
    $[161] = t58;
  } else {
    t58 = $[161];
  }
  let t59;
  if ($[162] !== t56 || $[163] !== t58) {
    t59 = [t56, t58];
    $[162] = t56;
    $[163] = t58;
    $[164] = t59;
  } else {
    t59 = $[164];
  }
  let t60;
  if ($[165] !== t54 || $[166] !== t59) {
    t60 = {
      name: t54,
      dropdownItems: t59,
      mobileIconRenderer: _temp6
    };
    $[165] = t54;
    $[166] = t59;
    $[167] = t60;
  } else {
    t60 = $[167];
  }
  let t61;
  if ($[168] !== t) {
    t61 = t("header.top_menu.automations");
    $[168] = t;
    $[169] = t61;
  } else {
    t61 = $[169];
  }
  let t62;
  if ($[170] !== t) {
    t62 = t("header.top_menu.rules");
    $[170] = t;
    $[171] = t62;
  } else {
    t62 = $[171];
  }
  let t63;
  if ($[172] !== isCustomer || $[173] !== regularIsActiveCheck || $[174] !== t62) {
    t63 = {
      name: t62,
      href: "/automation-rules",
      isActive: regularIsActiveCheck,
      shouldRender: isCustomer
    };
    $[172] = isCustomer;
    $[173] = regularIsActiveCheck;
    $[174] = t62;
    $[175] = t63;
  } else {
    t63 = $[175];
  }
  let t64;
  if ($[176] !== t) {
    t64 = t("header.top_menu.workflows");
    $[176] = t;
    $[177] = t64;
  } else {
    t64 = $[177];
  }
  let t65;
  if ($[178] !== isCustomer || $[179] !== regularIsActiveCheck || $[180] !== t64) {
    t65 = {
      name: t64,
      href: "/workflows",
      isActive: regularIsActiveCheck,
      shouldRender: isCustomer
    };
    $[178] = isCustomer;
    $[179] = regularIsActiveCheck;
    $[180] = t64;
    $[181] = t65;
  } else {
    t65 = $[181];
  }
  let t66;
  if ($[182] !== t63 || $[183] !== t65) {
    t66 = [t63, t65];
    $[182] = t63;
    $[183] = t65;
    $[184] = t66;
  } else {
    t66 = $[184];
  }
  let t67;
  if ($[185] !== t61 || $[186] !== t66) {
    t67 = {
      name: t61,
      dropdownItems: t66,
      mobileIconRenderer: _temp7
    };
    $[185] = t61;
    $[186] = t66;
    $[187] = t67;
  } else {
    t67 = $[187];
  }
  let t68;
  if ($[188] !== t) {
    t68 = t("header.top_menu.products");
    $[188] = t;
    $[189] = t68;
  } else {
    t68 = $[189];
  }
  let t69;
  if ($[190] !== t) {
    t69 = t("header.top_menu.physical_product");
    $[190] = t;
    $[191] = t69;
  } else {
    t69 = $[191];
  }
  let t70;
  if ($[192] !== isCustomer || $[193] !== regularIsActiveCheck || $[194] !== t69) {
    t70 = {
      name: t69,
      href: "/products",
      isActive: regularIsActiveCheck,
      shouldRender: isCustomer
    };
    $[192] = isCustomer;
    $[193] = regularIsActiveCheck;
    $[194] = t69;
    $[195] = t70;
  } else {
    t70 = $[195];
  }
  let t71;
  if ($[196] !== t) {
    t71 = t("header.top_menu.coupons");
    $[196] = t;
    $[197] = t71;
  } else {
    t71 = $[197];
  }
  let t72;
  if ($[198] !== isCustomer || $[199] !== regularIsActiveCheck || $[200] !== t71) {
    t72 = {
      name: t71,
      href: "/coupons",
      isActive: regularIsActiveCheck,
      shouldRender: isCustomer
    };
    $[198] = isCustomer;
    $[199] = regularIsActiveCheck;
    $[200] = t71;
    $[201] = t72;
  } else {
    t72 = $[201];
  }
  let t73;
  if ($[202] !== t) {
    t73 = t("header.top_menu.courses");
    $[202] = t;
    $[203] = t73;
  } else {
    t73 = $[203];
  }
  let t74;
  if ($[204] !== isCustomer || $[205] !== regularIsActiveCheck || $[206] !== t73) {
    t74 = {
      name: t73,
      href: "/courses",
      isActive: regularIsActiveCheck,
      shouldRender: isCustomer
    };
    $[204] = isCustomer;
    $[205] = regularIsActiveCheck;
    $[206] = t73;
    $[207] = t74;
  } else {
    t74 = $[207];
  }
  let t75;
  if ($[208] !== t) {
    t75 = t("header.top_menu.communities");
    $[208] = t;
    $[209] = t75;
  } else {
    t75 = $[209];
  }
  let t76;
  if ($[210] !== isCustomer || $[211] !== regularIsActiveCheck || $[212] !== t75) {
    t76 = {
      name: t75,
      href: "/communities",
      isActive: regularIsActiveCheck,
      shouldRender: isCustomer
    };
    $[210] = isCustomer;
    $[211] = regularIsActiveCheck;
    $[212] = t75;
    $[213] = t76;
  } else {
    t76 = $[213];
  }
  let t77;
  if ($[214] !== t) {
    t77 = t("header.top_menu.files");
    $[214] = t;
    $[215] = t77;
  } else {
    t77 = $[215];
  }
  let t78;
  if ($[216] !== isCustomer || $[217] !== regularIsActiveCheck || $[218] !== t77) {
    t78 = {
      name: t77,
      href: "/files",
      isActive: regularIsActiveCheck,
      shouldRender: isCustomer
    };
    $[216] = isCustomer;
    $[217] = regularIsActiveCheck;
    $[218] = t77;
    $[219] = t78;
  } else {
    t78 = $[219];
  }
  let t79;
  if ($[220] !== t70 || $[221] !== t72 || $[222] !== t74 || $[223] !== t76 || $[224] !== t78) {
    t79 = [t70, t72, t74, t76, t78];
    $[220] = t70;
    $[221] = t72;
    $[222] = t74;
    $[223] = t76;
    $[224] = t78;
    $[225] = t79;
  } else {
    t79 = $[225];
  }
  let t80;
  if ($[226] !== t68 || $[227] !== t79) {
    t80 = {
      name: t68,
      dropdownItems: t79,
      mobileIconRenderer: _temp8
    };
    $[226] = t68;
    $[227] = t79;
    $[228] = t80;
  } else {
    t80 = $[228];
  }
  let t81;
  if ($[229] !== t) {
    t81 = t("header.top_menu.sales");
    $[229] = t;
    $[230] = t81;
  } else {
    t81 = $[230];
  }
  let t82;
  if ($[231] !== t) {
    t82 = t("header.top_menu.orders");
    $[231] = t;
    $[232] = t82;
  } else {
    t82 = $[232];
  }
  let t83;
  if ($[233] !== isCustomer || $[234] !== regularIsActiveCheck || $[235] !== t82) {
    t83 = {
      name: t82,
      href: "/orders",
      isActive: regularIsActiveCheck,
      shouldRender: isCustomer
    };
    $[233] = isCustomer;
    $[234] = regularIsActiveCheck;
    $[235] = t82;
    $[236] = t83;
  } else {
    t83 = $[236];
  }
  let t84;
  if ($[237] !== t) {
    t84 = t("header.top_menu.transactions");
    $[237] = t;
    $[238] = t84;
  } else {
    t84 = $[238];
  }
  let t85;
  if ($[239] !== isCustomer || $[240] !== regularIsActiveCheck || $[241] !== t84) {
    t85 = {
      name: t84,
      href: "/payment/transactions",
      isActive: regularIsActiveCheck,
      shouldRender: isCustomer
    };
    $[239] = isCustomer;
    $[240] = regularIsActiveCheck;
    $[241] = t84;
    $[242] = t85;
  } else {
    t85 = $[242];
  }
  let t86;
  if ($[243] !== t) {
    t86 = t("header.top_menu.subscriptions");
    $[243] = t;
    $[244] = t86;
  } else {
    t86 = $[244];
  }
  let t87;
  if ($[245] !== isCustomer || $[246] !== regularIsActiveCheck || $[247] !== t86) {
    t87 = {
      name: t86,
      href: "/payment/subscriptions",
      isActive: regularIsActiveCheck,
      shouldRender: isCustomer
    };
    $[245] = isCustomer;
    $[246] = regularIsActiveCheck;
    $[247] = t86;
    $[248] = t87;
  } else {
    t87 = $[248];
  }
  let t88;
  if ($[249] !== t) {
    t88 = t("header.top_menu.affiliate_invoices");
    $[249] = t;
    $[250] = t88;
  } else {
    t88 = $[250];
  }
  let t89;
  bb1: {
    if (isWsAssistant) {
      t89 = false;
      break bb1;
    }
    let t90;
    if ($[251] === Symbol.for("react.memo_cache_sentinel")) {
      t90 = isSIO();
      $[251] = t90;
    } else {
      t90 = $[251];
    }
    t89 = t90;
  }
  let t90;
  if ($[252] !== regularIsActiveCheck || $[253] !== t88 || $[254] !== t89) {
    t90 = {
      name: t88,
      href: "/payment/affiliate-invoices",
      shouldRender: t89,
      isActive: regularIsActiveCheck
    };
    $[252] = regularIsActiveCheck;
    $[253] = t88;
    $[254] = t89;
    $[255] = t90;
  } else {
    t90 = $[255];
  }
  let t91;
  if ($[256] !== t) {
    t91 = t("header.top_menu.affiliate_program");
    $[256] = t;
    $[257] = t91;
  } else {
    t91 = $[257];
  }
  let t92;
  bb2: {
    if (!isWorkspaceOwner) {
      t92 = false;
      break bb2;
    }
    let t93;
    if ($[258] === Symbol.for("react.memo_cache_sentinel")) {
      t93 = isSIO();
      $[258] = t93;
    } else {
      t93 = $[258];
    }
    t92 = t93;
  }
  let t93;
  if ($[259] !== regularIsActiveCheck || $[260] !== t91 || $[261] !== t92) {
    t93 = {
      name: t91,
      href: "/affiliate-program",
      shouldRender: t92,
      isActive: regularIsActiveCheck
    };
    $[259] = regularIsActiveCheck;
    $[260] = t91;
    $[261] = t92;
    $[262] = t93;
  } else {
    t93 = $[262];
  }
  let t94;
  if ($[263] !== t83 || $[264] !== t85 || $[265] !== t87 || $[266] !== t90 || $[267] !== t93) {
    t94 = [t83, t85, t87, t90, t93];
    $[263] = t83;
    $[264] = t85;
    $[265] = t87;
    $[266] = t90;
    $[267] = t93;
    $[268] = t94;
  } else {
    t94 = $[268];
  }
  let t95;
  if ($[269] !== t81 || $[270] !== t94) {
    t95 = {
      name: t81,
      dropdownItems: t94,
      mobileIconRenderer: _temp9
    };
    $[269] = t81;
    $[270] = t94;
    $[271] = t95;
  } else {
    t95 = $[271];
  }
  let t96;
  if ($[272] !== t) {
    t96 = t("header.top_menu.admin.admin");
    $[272] = t;
    $[273] = t96;
  } else {
    t96 = $[273];
  }
  let t97;
  if ($[274] !== t) {
    t97 = t("header.top_menu.admin.users");
    $[274] = t;
    $[275] = t97;
  } else {
    t97 = $[275];
  }
  let t98;
  if ($[276] !== isRegularAdmin || $[277] !== regularIsActiveCheck || $[278] !== t97) {
    t98 = {
      name: t97,
      href: "/management/users",
      shouldRender: isRegularAdmin,
      isActive: regularIsActiveCheck
    };
    $[276] = isRegularAdmin;
    $[277] = regularIsActiveCheck;
    $[278] = t97;
    $[279] = t98;
  } else {
    t98 = $[279];
  }
  let t99;
  if ($[280] !== t) {
    t99 = t("header.top_menu.admin.templates");
    $[280] = t;
    $[281] = t99;
  } else {
    t99 = $[281];
  }
  let t100;
  if ($[282] !== t) {
    t100 = t("header.top_menu.admin.email_templates");
    $[282] = t;
    $[283] = t100;
  } else {
    t100 = $[283];
  }
  let t101;
  if ($[284] !== checkAdminRoles) {
    t101 = checkAdminRoles([AdminRolesEnum.contentManager, AdminRolesEnum.admin, AdminRolesEnum.superAdmin]);
    $[284] = checkAdminRoles;
    $[285] = t101;
  } else {
    t101 = $[285];
  }
  let t102;
  if ($[286] !== regularIsActiveCheck || $[287] !== t100 || $[288] !== t101) {
    t102 = {
      name: t100,
      href: "/management/email-templates",
      isActive: regularIsActiveCheck,
      shouldRender: t101
    };
    $[286] = regularIsActiveCheck;
    $[287] = t100;
    $[288] = t101;
    $[289] = t102;
  } else {
    t102 = $[289];
  }
  let t103;
  if ($[290] !== t) {
    t103 = t("header.top_menu.admin.page_templates");
    $[290] = t;
    $[291] = t103;
  } else {
    t103 = $[291];
  }
  let t104;
  if ($[292] !== checkAdminRoles) {
    t104 = checkAdminRoles([AdminRolesEnum.contentManager, AdminRolesEnum.admin, AdminRolesEnum.superAdmin]);
    $[292] = checkAdminRoles;
    $[293] = t104;
  } else {
    t104 = $[293];
  }
  let t105;
  if ($[294] !== regularIsActiveCheck || $[295] !== t103 || $[296] !== t104) {
    t105 = {
      name: t103,
      href: "/management/page-templates",
      isActive: regularIsActiveCheck,
      shouldRender: t104
    };
    $[294] = regularIsActiveCheck;
    $[295] = t103;
    $[296] = t104;
    $[297] = t105;
  } else {
    t105 = $[297];
  }
  let t106;
  if ($[298] !== t) {
    t106 = t("header.top_menu.admin.blog_templates");
    $[298] = t;
    $[299] = t106;
  } else {
    t106 = $[299];
  }
  let t107;
  if ($[300] !== checkAdminRoles) {
    t107 = checkAdminRoles([AdminRolesEnum.contentManager, AdminRolesEnum.admin, AdminRolesEnum.superAdmin]);
    $[300] = checkAdminRoles;
    $[301] = t107;
  } else {
    t107 = $[301];
  }
  let t108;
  if ($[302] !== regularIsActiveCheck || $[303] !== t106 || $[304] !== t107) {
    t108 = {
      name: t106,
      href: "/management/blog-templates",
      isActive: regularIsActiveCheck,
      shouldRender: t107
    };
    $[302] = regularIsActiveCheck;
    $[303] = t106;
    $[304] = t107;
    $[305] = t108;
  } else {
    t108 = $[305];
  }
  let t109;
  if ($[306] !== t) {
    t109 = t("header.top_menu.admin.website_templates");
    $[306] = t;
    $[307] = t109;
  } else {
    t109 = $[307];
  }
  let t110;
  if ($[308] !== checkAdminRoles) {
    t110 = checkAdminRoles([AdminRolesEnum.contentManager, AdminRolesEnum.admin, AdminRolesEnum.superAdmin]);
    $[308] = checkAdminRoles;
    $[309] = t110;
  } else {
    t110 = $[309];
  }
  let t111;
  if ($[310] !== regularIsActiveCheck || $[311] !== t109 || $[312] !== t110) {
    t111 = {
      name: t109,
      href: "/management/website-templates",
      shouldRender: t110,
      isActive: regularIsActiveCheck
    };
    $[310] = regularIsActiveCheck;
    $[311] = t109;
    $[312] = t110;
    $[313] = t111;
  } else {
    t111 = $[313];
  }
  let t112;
  if ($[314] !== t) {
    t112 = t("header.top_menu.admin.funnel_templates");
    $[314] = t;
    $[315] = t112;
  } else {
    t112 = $[315];
  }
  let t113;
  if ($[316] !== checkAdminRoles) {
    t113 = checkAdminRoles([AdminRolesEnum.contentManager, AdminRolesEnum.admin, AdminRolesEnum.superAdmin]);
    $[316] = checkAdminRoles;
    $[317] = t113;
  } else {
    t113 = $[317];
  }
  let t114;
  if ($[318] !== regularIsActiveCheck || $[319] !== t112 || $[320] !== t113) {
    t114 = {
      name: t112,
      href: "/management/funnel-templates",
      isActive: regularIsActiveCheck,
      shouldRender: t113
    };
    $[318] = regularIsActiveCheck;
    $[319] = t112;
    $[320] = t113;
    $[321] = t114;
  } else {
    t114 = $[321];
  }
  let t115;
  if ($[322] !== t102 || $[323] !== t105 || $[324] !== t108 || $[325] !== t111 || $[326] !== t114) {
    t115 = [t102, t105, t108, t111, t114];
    $[322] = t102;
    $[323] = t105;
    $[324] = t108;
    $[325] = t111;
    $[326] = t114;
    $[327] = t115;
  } else {
    t115 = $[327];
  }
  let t116;
  if ($[328] !== t115 || $[329] !== t99) {
    t116 = {
      name: t99,
      dropdownItems: t115
    };
    $[328] = t115;
    $[329] = t99;
    $[330] = t116;
  } else {
    t116 = $[330];
  }
  let t117;
  if ($[331] !== t) {
    t117 = t("header.top_menu.admin.customers");
    $[331] = t;
    $[332] = t117;
  } else {
    t117 = $[332];
  }
  let t118;
  if ($[333] !== checkAdminRoles) {
    t118 = checkAdminRoles([AdminRolesEnum.mailingManager, AdminRolesEnum.admin, AdminRolesEnum.superAdmin, AdminRolesEnum.support]);
    $[333] = checkAdminRoles;
    $[334] = t118;
  } else {
    t118 = $[334];
  }
  let t119;
  if ($[335] !== regularIsActiveCheck || $[336] !== t117 || $[337] !== t118) {
    t119 = {
      name: t117,
      href: "/management/user-customer-list",
      shouldRender: t118,
      isActive: regularIsActiveCheck
    };
    $[335] = regularIsActiveCheck;
    $[336] = t117;
    $[337] = t118;
    $[338] = t119;
  } else {
    t119 = $[338];
  }
  let t120;
  if ($[339] !== t) {
    t120 = t("header.top_menu.admin.emails");
    $[339] = t;
    $[340] = t120;
  } else {
    t120 = $[340];
  }
  let t121;
  if ($[341] !== isRegularAdmin || $[342] !== regularIsActiveCheck || $[343] !== t120) {
    t121 = {
      name: t120,
      href: "/management/emails-delivery-statistics",
      shouldRender: isRegularAdmin,
      isActive: regularIsActiveCheck
    };
    $[341] = isRegularAdmin;
    $[342] = regularIsActiveCheck;
    $[343] = t120;
    $[344] = t121;
  } else {
    t121 = $[344];
  }
  let t122;
  if ($[345] !== t) {
    t122 = t("header.top_menu.admin.user_plans");
    $[345] = t;
    $[346] = t122;
  } else {
    t122 = $[346];
  }
  const t123 = !isWsAssistant && isRegularAdmin;
  let t124;
  if ($[347] !== regularIsActiveCheck || $[348] !== t122 || $[349] !== t123) {
    t124 = {
      name: t122,
      href: "/management/user-plans",
      shouldRender: t123,
      isActive: regularIsActiveCheck
    };
    $[347] = regularIsActiveCheck;
    $[348] = t122;
    $[349] = t123;
    $[350] = t124;
  } else {
    t124 = $[350];
  }
  let t125;
  if ($[351] !== t) {
    t125 = t("header.top_menu.admin.domains_blocked");
    $[351] = t;
    $[352] = t125;
  } else {
    t125 = $[352];
  }
  let t126;
  if ($[353] !== isRegularAdmin || $[354] !== regularIsActiveCheck || $[355] !== t125) {
    t126 = {
      name: t125,
      href: "/management/blocked-mailbox-provider",
      shouldRender: isRegularAdmin,
      isActive: regularIsActiveCheck
    };
    $[353] = isRegularAdmin;
    $[354] = regularIsActiveCheck;
    $[355] = t125;
    $[356] = t126;
  } else {
    t126 = $[356];
  }
  let t127;
  if ($[357] !== t) {
    t127 = t("header.top_menu.admin.domains_white_listed");
    $[357] = t;
    $[358] = t127;
  } else {
    t127 = $[358];
  }
  let t128;
  if ($[359] !== isRegularAdmin || $[360] !== regularIsActiveCheck || $[361] !== t127) {
    t128 = {
      name: t127,
      href: "/management/white-list-mailbox",
      shouldRender: isRegularAdmin,
      isActive: regularIsActiveCheck
    };
    $[359] = isRegularAdmin;
    $[360] = regularIsActiveCheck;
    $[361] = t127;
    $[362] = t128;
  } else {
    t128 = $[362];
  }
  let t129;
  if ($[363] !== t) {
    t129 = t("header.top_menu.admin.suspicious_content");
    $[363] = t;
    $[364] = t129;
  } else {
    t129 = $[364];
  }
  let t130;
  if ($[365] !== t) {
    t130 = t("header.top_menu.admin.suspicious_page_content_keywords");
    $[365] = t;
    $[366] = t130;
  } else {
    t130 = $[366];
  }
  let t131;
  if ($[367] !== isRegularAdmin || $[368] !== regularIsActiveCheck || $[369] !== t130) {
    t131 = {
      name: t130,
      href: "/management/suspicious-page-content-keyword",
      isActive: regularIsActiveCheck,
      shouldRender: isRegularAdmin
    };
    $[367] = isRegularAdmin;
    $[368] = regularIsActiveCheck;
    $[369] = t130;
    $[370] = t131;
  } else {
    t131 = $[370];
  }
  let t132;
  if ($[371] !== t) {
    t132 = t("header.top_menu.admin.suspicious_email_keywords");
    $[371] = t;
    $[372] = t132;
  } else {
    t132 = $[372];
  }
  let t133;
  if ($[373] !== isRegularAdmin || $[374] !== regularIsActiveCheck || $[375] !== t132) {
    t133 = {
      name: t132,
      href: "/management/suspicious-email-keyword",
      isActive: regularIsActiveCheck,
      shouldRender: isRegularAdmin
    };
    $[373] = isRegularAdmin;
    $[374] = regularIsActiveCheck;
    $[375] = t132;
    $[376] = t133;
  } else {
    t133 = $[376];
  }
  let t134;
  if ($[377] !== t) {
    t134 = t("header.top_menu.admin.suspicious_email_address");
    $[377] = t;
    $[378] = t134;
  } else {
    t134 = $[378];
  }
  let t135;
  if ($[379] !== isRegularAdmin || $[380] !== regularIsActiveCheck || $[381] !== t134) {
    t135 = {
      name: t134,
      href: "/management/suspicious-email-address",
      isActive: regularIsActiveCheck,
      shouldRender: isRegularAdmin
    };
    $[379] = isRegularAdmin;
    $[380] = regularIsActiveCheck;
    $[381] = t134;
    $[382] = t135;
  } else {
    t135 = $[382];
  }
  let t136;
  if ($[383] !== t131 || $[384] !== t133 || $[385] !== t135) {
    t136 = [t131, t133, t135];
    $[383] = t131;
    $[384] = t133;
    $[385] = t135;
    $[386] = t136;
  } else {
    t136 = $[386];
  }
  let t137;
  if ($[387] !== t129 || $[388] !== t136) {
    t137 = {
      name: t129,
      dropdownItems: t136
    };
    $[387] = t129;
    $[388] = t136;
    $[389] = t137;
  } else {
    t137 = $[389];
  }
  let t138;
  if ($[390] !== t) {
    t138 = t("header.top_menu.admin.statistics");
    $[390] = t;
    $[391] = t138;
  } else {
    t138 = $[391];
  }
  let t139;
  if ($[392] !== checkAdminRoles || $[393] !== isWorkspaceOwner || $[394] !== isWsAdmin) {
    t139 = (isWorkspaceOwner || isWsAdmin) && checkAdminRoles([AdminRolesEnum.superAdmin]);
    $[392] = checkAdminRoles;
    $[393] = isWorkspaceOwner;
    $[394] = isWsAdmin;
    $[395] = t139;
  } else {
    t139 = $[395];
  }
  let t140;
  if ($[396] !== regularIsActiveCheck || $[397] !== t138 || $[398] !== t139) {
    t140 = {
      name: t138,
      href: "/management/statistics",
      shouldRender: t139,
      isActive: regularIsActiveCheck
    };
    $[396] = regularIsActiveCheck;
    $[397] = t138;
    $[398] = t139;
    $[399] = t140;
  } else {
    t140 = $[399];
  }
  let t141;
  if ($[400] !== t116 || $[401] !== t119 || $[402] !== t121 || $[403] !== t124 || $[404] !== t126 || $[405] !== t128 || $[406] !== t137 || $[407] !== t140 || $[408] !== t98) {
    t141 = [t98, t116, t119, t121, t124, t126, t128, t137, t140];
    $[400] = t116;
    $[401] = t119;
    $[402] = t121;
    $[403] = t124;
    $[404] = t126;
    $[405] = t128;
    $[406] = t137;
    $[407] = t140;
    $[408] = t98;
    $[409] = t141;
  } else {
    t141 = $[409];
  }
  let t142;
  if ($[410] !== t141 || $[411] !== t96) {
    t142 = {
      name: t96,
      dropdownItems: t141,
      mobileIconRenderer: _temp10
    };
    $[410] = t141;
    $[411] = t96;
    $[412] = t142;
  } else {
    t142 = $[412];
  }
  let t143;
  if ($[413] !== t) {
    t143 = t("header.top_menu.help");
    $[413] = t;
    $[414] = t143;
  } else {
    t143 = $[414];
  }
  const t144 = user?.dashboardLocale === LocaleEnum.ENGLISH ? `${process.env.NEXT_PUBLIC_SIO_HOST_SCHEME}://${process.env.NEXT_PUBLIC_SIO_HOST_NAME}/help` : `${process.env.NEXT_PUBLIC_SIO_HOST_SCHEME}://${process.env.NEXT_PUBLIC_SIO_HOST_NAME}/${user?.dashboardLocale}/help`;
  let t145;
  if ($[415] === Symbol.for("react.memo_cache_sentinel")) {
    t145 = isSIO();
    $[415] = t145;
  } else {
    t145 = $[415];
  }
  let t146;
  if ($[416] !== regularIsActiveCheck || $[417] !== t143 || $[418] !== t144) {
    t146 = {
      name: t143,
      href: t144,
      target: "__blank",
      mobileIconRenderer: _temp11,
      shouldRender: t145,
      isActive: regularIsActiveCheck
    };
    $[416] = regularIsActiveCheck;
    $[417] = t143;
    $[418] = t144;
    $[419] = t146;
  } else {
    t146 = $[419];
  }
  let t147;
  if ($[420] !== t142 || $[421] !== t146 || $[422] !== t21 || $[423] !== t33 || $[424] !== t4 || $[425] !== t44 || $[426] !== t53 || $[427] !== t60 || $[428] !== t67 || $[429] !== t80 || $[430] !== t95) {
    const menuItems = [t4, t21, t33, t44, t53, t60, t67, t80, t95, t142, t146];
    t147 = {
      menuItems
    };
    $[420] = t142;
    $[421] = t146;
    $[422] = t21;
    $[423] = t33;
    $[424] = t4;
    $[425] = t44;
    $[426] = t53;
    $[427] = t60;
    $[428] = t67;
    $[429] = t80;
    $[430] = t95;
    $[431] = t147;
  } else {
    t147 = $[431];
  }
  return t147;
};
function _temp() {
  return <UpgradeIcon />;
}
function _temp2() {
  return <DashboardIcon />;
}
function _temp3() {
  return <ContactsIcon />;
}
function _temp4() {
  return <BlogsIcon />;
}
function _temp5() {
  return <EmailsIcon />;
}
function _temp6() {
  return <SmsMenuIcon />;
}
function _temp7() {
  return <AutomationsIcon />;
}
function _temp8() {
  return <ProductsIcon />;
}
function _temp9() {
  return <SalesIcon />;
}
function _temp10() {
  return <ManInSuit />;
}
function _temp11() {
  return <HelpIcon />;
}